import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';

import { flex } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { PositionEvent } from '@flipster/utils/segment/events/position';

import MinusIcon from '../icon/minus-small.svg';
import PlusIcon from '../icon/plus-small.svg';
import { adjustLeverageModalBunja } from '../state';

const buttonStyle = flex({
  align: 'center',
  justify: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '4px',
  bg: 'background.default.level-3',
});

interface LeverageStepperProps {
  max: number;
  symbol: string;
}

export const LeverageStepper = ({ max, symbol }: LeverageStepperProps) => {
  const { leverageAtom } = useBunja(adjustLeverageModalBunja);
  const [leverage, setLeverage] = useAtom(leverageAtom);

  const decreaseLeverage = () => {
    if (leverage <= 1) return;
    setLeverage((leverage) => leverage - 1);
    segment.track(PositionEvent.AdjustLeverageUpdownClick, { symbol, side: 'down' });
  };

  const increaseLeverage = () => {
    if (leverage >= max) return;
    setLeverage((leverage) => leverage + 1);
    segment.track(PositionEvent.AdjustLeverageUpdownClick, { symbol, side: 'up' });
  };

  return (
    <>
      <button type='button' className={buttonStyle} onClick={decreaseLeverage}>
        <MinusIcon />
      </button>
      <button type='button' className={buttonStyle} onClick={increaseLeverage}>
        <PlusIcon />
      </button>
    </>
  );
};
